import { EnvironmentProviders, Provider } from '@angular/core';
import {
  belegleserConfig,
  BelegleserConfig,
  SOFTLINE_CONFIG_BELEGLESER,
} from './belegleser.shared';

// Composed at boot by provideBelegleserModule (monolith) and ./ModuleGlobals (federation).
// Must not import the routes file.
export function provideBelegleserGlobals(
  config?: BelegleserConfig
): Array<Provider | EnvironmentProviders> {
  return config
    ? [{ provide: SOFTLINE_CONFIG_BELEGLESER, useValue: belegleserConfig(config) }]
    : [];
}
